import { Routes } from '@angular/router';

export const settingsRoutes: Routes = [
  {
    path: 'settings',
    loadComponent: () =>
      import('@softapps/core/pages').then((o) => o.SettingsComponent),
  },
];
